import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import light from '../../assets/images/button_light.png';
import shadow from '../../assets/images/result_bg.png';

const StyledWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 10;
	width: 100%;
	height: 100%;
	transition: opacity 0.3s;
	opacity: 0;
	background: radial-gradient(
			50% 50% at 50% 50%,
			#111314 0%,
			rgba(17, 19, 20, 0) 100%
		),
		rgba(17, 19, 20, 0.98);

	&.result-enter {
		opacity: 0;

		.resultImage {
			opacity: 0;
			transform: translateX(-200px);
		}
	}

	&.result-enter-active,
	&.result-enter-done,
	&.result-exit {
		opacity: 1;

		.resultImage {
			opacity: 1;
			transform: translateY(0);
		}
	}

	&.result-exit-active {
		opacity: 0;

		.resultImage {
			opacity: 0;
			transform: translateY(200px);
		}
	}
`;

const StyledShadow = styled.div`
	position: absolute;
	top: -1100px;
	left: 50%;
	transform: translateX(-50%);
	mask-image: url(${shadow});
	mask-size: 2220px 2440px;
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${shadow});
	-webkit-mask-size: 2220px 2440px;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	width: 2220px;
	height: 2440px;
	pointer-events: none;
`;

const StyledContainer = styled.div`
	position: absolute;
	top: 203px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	flex-direction: column;
`;

const StyledCategory = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 10px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
	height: 30px;

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledName = styled(Text)`
	font-weight: 500;
	font-size: 24px;
	color: #ffffff;
	margin-top: 30px;
`;

const StyledImage = styled.img`
	width: 300px;
	height: 300px;
	margin-top: 100px;
	user-select: none;
	pointer-events: none;
`;

const StyledButtonLight = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: -1;
	width: 413px;
	height: 300px;
	mask-image: url(${light});
	mask-size: 413px 300px;
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${light});
	-webkit-mask-size: 413px 300px;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	background-color: #2d70da;
	pointer-events: none;
	transition:
		background-color 0.3s,
		opacity 0.3s;
`;

const StyledButtonContainer = styled.div`
	position: relative;
	margin-top: 100px;

	&:hover {
		${StyledButtonLight} {
			background-color: #ffffff;
			opacity: 0.5;
		}
	}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export {
	StyledButtonContainer,
	StyledButtonContent,
	StyledButtonLight,
	StyledCategory,
	StyledContainer,
	StyledImage,
	StyledName,
	StyledShadow,
	StyledWrapper,
};
